import { css } from 'lit';

export const styles = css`igc-textarea::part(input){max-height:10.625rem;padding-block:.5rem}[part~=dragging] igc-textarea::part(input){border:.0625rem solid var(--focused-border-color);box-shadow:0 0 0 .25rem var(--focused-secondary-color)}`;
